import { ServicePackageEnum } from "@repo/lib/src/enums";
import { createFileRoute } from "@tanstack/react-router";
import { Left } from "@repo/icons";
import { validatePackageAccess } from "@/lib/assist-package-guard";
import { Page } from "@/components/page";
import { HeaderRoot, HeaderTitle, HeaderUpButton } from "@/components/header";
import { UnsubscribeAssistProComponent } from "@/components/unsubscribe-assist-pro";

export const UnsubscribeAssistProPage = (): JSX.Element => {
  return (
    <>
      <HeaderRoot>
        <HeaderUpButton icon={Left} align="start" />
        <HeaderTitle title="Cancelamento" align="center" />
      </HeaderRoot>
      <Page className="px-0 pb-0 flex flex-col">
        <UnsubscribeAssistProComponent />
      </Page>
    </>
  );
};

export const Route = createFileRoute("/settings/assist/unsubscribe-assist-pro/")({
  component: UnsubscribeAssistProPage,
  beforeLoad: ({ context }) => {
    const user = context.user;
    validatePackageAccess({
      user,
      packageService: ServicePackageEnum.Pro,
    });
  },
});
